import { useEffect, useRef } from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import Image from 'next/future/image'
import '@splidejs/react-splide/css'

export default function PluginsImagePreviewSlider ({ onHide, medias, start, videoLink }) {
  const previewSlider = useRef(null)
  const options = {
    type: 'loop',
    start
  }

  useEffect(() => {
    const productSlider = new window.bootstrap.Modal('#productSlider')

    // This component only gets rendered when the modal is opened so we toggle it onMounted
    productSlider.toggle()
    previewSlider.current.splide.refresh()

    document.getElementById('productSlider').addEventListener('hide.bs.modal', () => {
      onHide(false)
    })
  }, [])

  return (
    <div
      id="productSlider"
      className="modal modal-xl"
      tabIndex="-1"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body">
            <Splide
              options={options}
              ref={previewSlider}
            >
              {
                videoLink && (
                  <SplideSlide>
                    <iframe
                      id={'slideimage0'}
                      width="560"
                      height="315"
                      src={videoLink.startsWith('https://www.youtube.com')
                        ? videoLink.replace('watch?v=', 'embed/')
                        : videoLink.replace('vimeo.com', 'player.vimeo.com/video')}
                      allowFullScreen
                      style={{ objectFit: 'cover', width: '100%', height: '100%', minHeight: '600px' }}
                    >
                    </iframe>
                  </SplideSlide>
                )
              }
              {
                medias.map((media, index) => (
                  <SplideSlide key={videoLink ? index + 1 : index}>
                    <Image
                      alt=""
                      id={`slideimage${videoLink ? index + 1 : index}`}
                      style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
                      src={media.media.url}
                      width={media.media.width}
                      height={media.media.height}
                    />
                  </SplideSlide>
                ))
              }
            </Splide>
          </div>
        </div>
      </div>
    </div>
  )
}
